export default `
mutation($input: EditAccountInput){
    editAccount(input: $input){
      sortKey
      name
      domain
      timezone
      weekStart
      logo
    }
  }
`;
